<template>
  <div>
    <b-row>
      <b-form-group label="Agência origem" class="cols col-3"> 
        <dbs-agencia
                v-model="model.agenciaOrigem"
                single
              ></dbs-agencia>
      </b-form-group>
      <b-form-group label="Conta origem" class="cols col-3">
        <dbs-conta
          v-model="model.contaOrigem"
          :codigoAgencia="model.agenciaOrigem"
          :disabled="!model.agenciaOrigem"
        />
      </b-form-group>
      <b-form-group label="Agência destino" class="cols col-3"> 
        <dbs-agencia
                v-model="model.agenciaDestino"
                single
              ></dbs-agencia>
      </b-form-group>
      <b-form-group label="Conta destino" class="cols col-3">
        <dbs-conta
          v-model="model.contaDestino"
          :codigoAgencia="model.agenciaDestino"
          :disabled="!model.agenciaDestino"
        />
      </b-form-group>
    </b-row>
    <b-row>
      <b-col sm="3">
        <b-form-group label="Data inicial">
          <kendo-datepicker v-model="model.dtInicio"
                            :max="dtMax"
                            v-mask="'##/##/####'"
                            :format="'dd/MM/yyyy'"
                            :required="requiredData && dataInicialRequired"></kendo-datepicker>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group label="Data final">
          <kendo-datepicker v-model="model.dtFim"
                            :min="dtMin"
                            :max="new Date()"
                            v-mask="'##/##/####'"
                            :format="'dd/MM/yyyy'"
                            :required="requiredData && dataFinalRequired"></kendo-datepicker>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        agencias: [],
        contasOrigem: [],
        contasDestino: [],
        tipoAgencia: [{ value: 1, text: 'Agência Origem' }, {value: 2, text:'Agência Destino'}]
      }
    },
    props: {
      value: { type: Object },
      dtIniText: { type: String, default: 'Data Inicial' },
      dtFimText: { type: String, default: 'Data Final' },
      requiredData: { type: Boolean, default: true },
      dataInicialRequired: { type: Boolean, default: true },
      dataFinalRequired: { type: Boolean, default: true }
    },
    computed: { 
      dtMin: function () {
        return this.model.dtInicio
          ? kendo.parseDate(this.model.dtInicio)
          : new Date('1970-01-01Z00:00:00:000')
      },
      dtMax: function () {
        return this.model.dtFim ? kendo.parseDate(this.model.dtFim) : new Date()
      },
      model: {
        get() {
          var obj = this.value
          return obj
        },
        set(value) {
          this.$emit('input', value)
        }
      }
    },
    created() {
      this.loadComboAgencia();
    },
    methods: {
      refresh() {
        this.$emit('refresh')
      }
    }
  }
</script>

